import { DefectReportEntryDto } from 'generated/apiSchemas';
import { db, DefectReport, StrokePoint } from 'technical/db';

export const defectReportSyncService = {
  async download(defects: DefectReportEntryDto[]): Promise<void> {
    await db.defectReports.bulkPut(
      defects.map((defect) => ({
        ...defect,
        strokes: defect.strokes as unknown as StrokePoint[],
        desynchronizedAt: null,
        deletedAt: null,
      })),
    );
  },

  async getUnsyncedBatch(limit: number): Promise<DefectReport[]> {
    return db.defectReports
      .filter((defect) => defect.desynchronizedAt !== null)
      .limit(limit)
      .toArray();
  },

  async markAsSynchronized(ids: string[]): Promise<void> {
    await db.defectReports.bulkUpdate(
      ids.map((id) => {
        return {
          key: id,
          changes: {
            desynchronizedAt: null,
          },
        };
      }),
    );
  },

  async reset(): Promise<void> {
    await db.defectReports.clear();
  },
};
